import { render, staticRenderFns } from "./DashboardWidgetListEdit.vue?vue&type=template&id=32036e59&scoped=true&"
import script from "./DashboardWidgetListEdit.vue?vue&type=script&lang=ts&"
export * from "./DashboardWidgetListEdit.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardWidgetListEdit.vue?vue&type=style&index=0&id=32036e59&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32036e59",
  null
  
)

export default component.exports